import $ from 'jquery'

$(document).ready(function() {
  co_vc_history()
})

function co_vc_history() {
  $('.co_vc_history').each(function() {})
}
